// utils/icons.js
import React from "react";

export const CompanyManagementIcon = ({ size = 24, color = "#000000" }) => (
 <svg
   width={size}
   height={size}
   viewBox="0 0 24 24"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
 >
   <g clipPath="url(#clip0_4418_10099)">
     <path
       d="M2 22H22"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M17 2H7C4 2 3 3.79 3 6V22H21V6C21 3.79 20 2 17 2Z"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M7 16.5H10"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M14 16.5H17"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M7 12H10"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M14 12H17"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M7 7.5H10"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M14 7.5H17"
       stroke={color}
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
   </g>
   <defs>
     <clipPath id="clip0_4418_10099">
       <rect width="24" height="24" fill="white" />
     </clipPath>
   </defs>
 </svg>
);

export const ProductMasterIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4418_7066)">
      <path
        d="M12.0001 13.3008C11.8701 13.3008 11.7401 13.2708 11.6201 13.2008L2.79008 8.09083C2.44008 7.88083 2.31008 7.42083 2.52008 7.06083C2.73008 6.70083 3.19008 6.58083 3.55008 6.79083L12.0001 11.6808L20.4001 6.82083C20.7601 6.61083 21.2201 6.74083 21.4301 7.09083C21.6401 7.45083 21.5101 7.91083 21.1601 8.12083L12.3901 13.2008C12.2601 13.2608 12.1301 13.3008 12.0001 13.3008Z"
        fill={color}
      />
      <path
        d="M12 22.3591C11.59 22.3591 11.25 22.0191 11.25 21.6091V12.5391C11.25 12.1291 11.59 11.7891 12 11.7891C12.41 11.7891 12.75 12.1291 12.75 12.5391V21.6091C12.75 22.0191 12.41 22.3591 12 22.3591Z"
        fill={color}
      />
      <path
        d="M11.9999 22.75C11.1199 22.75 10.2499 22.56 9.55989 22.18L4.21989 19.21C2.76989 18.41 1.63989 16.48 1.63989 14.82V9.17C1.63989 7.51 2.76989 5.59 4.21989 4.78L9.55989 1.82C10.9299 1.06 13.0699 1.06 14.4399 1.82L19.7799 4.79C21.2299 5.59 22.3599 7.52 22.3599 9.18V14.83C22.3599 16.49 21.2299 18.41 19.7799 19.22L14.4399 22.18C13.7499 22.56 12.8799 22.75 11.9999 22.75ZM11.9999 2.75C11.3699 2.75 10.7499 2.88 10.2899 3.13L4.94989 6.1C3.98989 6.63 3.13989 8.07 3.13989 9.17V14.82C3.13989 15.92 3.98989 17.36 4.94989 17.9L10.2899 20.87C11.1999 21.38 12.7999 21.38 13.7099 20.87L19.0499 17.9C20.0099 17.36 20.8599 15.93 20.8599 14.82V9.17C20.8599 8.07 20.0099 6.63 19.0499 6.09L13.7099 3.12C13.2499 2.88 12.6299 2.75 11.9999 2.75Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_4418_7066">
        <rect width="24" height="24" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export const InwardManagementIcon = ({ size = 24, color = "#000000" }) => (
 <svg
   width={size}
   height={size}
   viewBox="0 0 24 24"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
 >
   <g clipPath="url(#clip0_4418_10078)">
     <path
       d="M16.5 14.5L12.3 10.3L10.7 12.7L7.5 9.5"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M14.5 14.5H16.5V12.5"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
   </g>
   <defs>
     <clipPath id="clip0_4418_10078">
       <rect width="24" height="24" fill="white" />
     </clipPath>
   </defs>
 </svg>
);

export const OutwardManagementIcon = ({ size = 24, color = "#000000" }) => (
 <svg
   width={size}
   height={size}
   viewBox="0 0 24 24"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
 >
   <g clipPath="url(#clip0_4418_10076)">
     <path
       d="M16.5 9.5L12.3 13.7L10.7 11.3L7.5 14.5"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M14.5 9.5H16.5V11.5"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
   </g>
   <defs>
     <clipPath id="clip0_4418_10076">
       <rect width="24" height="24" fill="white" />
     </clipPath>
   </defs>
 </svg>
);
export const ReturnManagementIcon = ({ size = 24, color = "#000000" }) => (
 <svg
   width={size}
   height={size}
   viewBox="0 0 24 24"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
 >
   <path
     d="M3.58008 5.16016H17.4201C19.0801 5.16016 20.4201 6.50016 20.4201 8.16016V11.4802"
     stroke={color}
     strokeWidth="1.5"
     strokeMiterlimit="10"
     strokeLinecap="round"
     strokeLinejoin="round"
   />
   <path
     d="M6.74008 2L3.58008 5.15997L6.74008 8.32001"
     stroke={color}
     strokeWidth="1.5"
     strokeMiterlimit="10"
     strokeLinecap="round"
     strokeLinejoin="round"
   />
   <path
     d="M20.4201 18.8395H6.58008C4.92008 18.8395 3.58008 17.4995 3.58008 15.8395V12.5195"
     stroke={color}
     strokeWidth="1.5"
     strokeMiterlimit="10"
     strokeLinecap="round"
     strokeLinejoin="round"
   />
   <path
     d="M17.2603 21.9997L20.4203 18.8397L17.2603 15.6797"
     stroke={color}
     strokeWidth="1.5"
     strokeMiterlimit="10"
     strokeLinecap="round"
     strokeLinejoin="round"
   />
 </svg>
);

// Putaway Management
export const PutawayManagementIcon = ({ size = 24, color = "#000000" }) => (
 <svg
   width={size}
   height={size}
   viewBox="0 0 24 24"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
 >
   <g clipPath="url(#clip0_4418_9716)">
     <path
       d="M12.37 8.88086H17.62"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M6.38 8.88086L7.13 9.63086L9.38 7.38086"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M12.37 15.8809H17.62"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M6.38 15.8809L7.13 16.6309L9.38 14.3809"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
   </g>
   <defs>
     <clipPath id="clip0_4418_9716">
       <rect width="24" height="24" fill="white" />
     </clipPath>
   </defs>
 </svg>
);

// Bin Management
export const BinManagementIcon = ({ size = 24, color = "#000000" }) => (
 <svg
   width={size}
   height={size}
   viewBox="0 0 24 24"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
 >
   <g clipPath="url(#clip0_4418_9499)">
     <path
       d="M3.17004 7.43945L12 12.5494L20.77 7.46942"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M12 21.6091V12.5391"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M9.92999 2.48L4.59 5.45003C3.38 6.12003 2.39001 7.80001 2.39001 9.18001V14.83C2.39001 16.21 3.38 17.89 4.59 18.56L9.92999 21.53C11.07 22.16 12.94 22.16 14.08 21.53L19.42 18.56C20.63 17.89 21.62 16.21 21.62 14.83V9.18001C21.62 7.80001 20.63 6.12003 19.42 5.45003L14.08 2.48C12.93 1.84 11.07 1.84 9.92999 2.48Z"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
     <path
       d="M17 13.2396V9.57965L7.51001 4.09961"
       stroke={color}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
   </g>
   <defs>
     <clipPath id="clip0_4418_9499">
       <rect width="24" height="24" fill="white" />
     </clipPath>
   </defs>
 </svg>
);
// Reports Management (NEW)
export const ReportsManagementIcon = ({ size = 24, color = "#000000" }) => (
 <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
   <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
   <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
   <path d="M7 13H13" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
   <path d="M7 17H11" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
 </svg>
);
export const LogoutIcon = ({ size = 24, color = "#000000" }) => (
 <svg
   width={size}
   height={size}
   viewBox="0 0 15 15"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
 >
   <path
     d="M13.5 7.5L10.5 10.75M13.5 7.5L10.5 4.5M13.5 7.5L4 7.5M8 13.5H1.5L1.5 1.5L8 1.5"
     stroke={color}
     strokeWidth="1.5"
     strokeLinecap="round"
     strokeLinejoin="round"
   />
 </svg>
);